import { useState } from 'react';

import ServiceLogo from './ServiceLogo';

interface ServiceProductImageProps {
  src?: string;
  alt: string;
}

export const ServiceProductImage = ({ src, alt }: ServiceProductImageProps) => {
  const [hasError, setHasError] = useState(false);

  if (!src || hasError) {
    return <ServiceLogo />;
  }

  return <img src={src} alt={alt} onError={() => setHasError(true)} />;
};

export default ServiceProductImage;
